import { Input } from 'antd'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import './labSampleSealsSection.less'

const LabSampleSealsSection = () => {
  const { t } = useTranslation()
  const { register } = useFormContext()

  return (
    <div className="lab-card">
      {/* Three-column header: title | Surveyor/Vessel | Supplier */}
      <div className="lab-card__header lab-seals-header">
        <span className="lab-seals-header__title">
          {t('rob.survey.bunker.lab.sampleSeals.title')}
        </span>
        <span className="lab-seals-header__col">
          {t('rob.survey.bunker.lab.sampleSeals.surveyorVesselHeader')}
        </span>
        <span className="lab-seals-header__col">
          {t('rob.survey.bunker.lab.sampleSeals.supplierHeader')}
        </span>
      </div>

      <div className="lab-card__body">
        <div className="lab-seals-row">
          {/* Seal description */}
          <span className="lab-seals-row__desc">
            {t('rob.survey.bunker.lab.sampleSeals.sealVolume')}{' '}
            <span className="lab-seals-row__qty">
              ({t('rob.survey.bunker.lab.sampleSeals.quantity')})
            </span>
          </span>

          {/* Surveyor / Vessel input */}
          <div className="lab-seals-row__cell">
            <Input
              {...register('laboratory.sampleSeals.surveyorVessel')}
              className="lab-seals-row__input"
              placeholder={t(
                'rob.survey.bunker.lab.sampleSeals.requiredPlaceholder'
              )}
            />
            <span className="lab-seals-row__asterisk">*</span>
          </div>

          {/* Supplier input */}
          <div className="lab-seals-row__cell">
            <Input
              {...register('laboratory.sampleSeals.supplier')}
              className="lab-seals-row__input"
              placeholder={t(
                'rob.survey.bunker.lab.sampleSeals.requiredPlaceholder'
              )}
            />
            <span className="lab-seals-row__asterisk">*</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LabSampleSealsSection
